import * as fileSaver from 'file-saver'
import { PaymentTypeEnum } from '@/constant'

/**
 * 是否是 cod
 * @param provider_payment_type
 * @returns
 */
export const isCodFn = (provider_payment_type?: string | number) => Number(provider_payment_type) === PaymentTypeEnum.cod

export const shouldUpdateFn = (fields: string[]) => (prev: Record<string, any>, next: Record<string, any>) => {
  return fields.some((key) => prev[key] !== next[key])
}

export const saveFile = (url?: string) => {
  if (!url) return
  const name = url.split('/').slice(-1)?.[0]
  fileSaver.saveAs(url, name)
}
